import { render, staticRenderFns } from "./TimeGuruVip.vue?vue&type=template&id=bfe1564a&scoped=true"
import script from "./TimeGuruVip.vue?vue&type=script&lang=js"
export * from "./TimeGuruVip.vue?vue&type=script&lang=js"
import style0 from "./TimeGuruVip.vue?vue&type=style&index=0&id=bfe1564a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe1564a",
  null
  
)

export default component.exports